import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import API from "./api/index";
import dayjs from 'dayjs'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/style/index.scss'

Vue.config.productionTip = false
Vue.prototype.$API = API
Vue.prototype.$dayjs = dayjs

// 埋点功能已测试,需要时候开启
// import track from '@/utils/directive.js'
// Vue.use(track)

Vue.use(ElementUI)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
